import './Documents.css';
import '../../Dashboard.css';
import Search from './Search/Search.js';
import Upload from './Upload/Upload.js';
import { useMemo, useState } from 'react';

const VIEWS = [
    {
        id: 'search-documents',
        title: 'Search',
        component: Search,
    },
];
const DEFAULT_VIEW = VIEWS[0];

function Documents({ toggleNav, currentClientID, setCurrentClientID, currentClientName }) {
    const [view, setView] = useState(DEFAULT_VIEW);

    const renderView = useMemo(() => {
        if (!view) return null;
        const View = view.component;
        return <View key={view.id} toggleNav={toggleNav} currentClientID={currentClientID} setCurrentClientID={setCurrentClientID} currentClientName={currentClientName} />
    }, [view, toggleNav, currentClientID, currentClientName]);

    return (
        <div className="Documents">
            {renderView}
        </div>
    );

}


export default Documents;
